import { z } from 'zod';

import { defineInvisible } from '@apps/web/features/phoebe_chat_v3/registry/types';

const observedOutreachUpdatedPayloadSchema = z
    .object({
        outreach_id: z.uuid(),
    })
    .strip();

export const observedOutreachUpdatedDefinitions = {
    observed_outreach_updated: defineInvisible('observed_outreach_updated', {
        disposition: 'invisible',
        schema: observedOutreachUpdatedPayloadSchema,
        malformed: { kind: 'skip' },
        evidence: null,
    }),
} as const;

export const observedOutreachUpdatedContractFixtures = {
    valid: {
        outreach_id: '00000000-0000-4000-8000-000000000001',
    },
    malformed: {
        outreach_id: 'not-a-uuid',
    },
} as const;
